var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBigCheckmark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#FED3B5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.441 21.7685L16.7789 25.9341C17.1662 26.306 17.778 26.3056 18.1649 25.9333L27.5601 16.8919C28.2372 16.2404 28.2372 15.1567 27.5601 14.5051C26.9188 13.888 25.9045 13.888 25.2632 14.5051L17.4689 22.0059L14.7353 19.3798C14.0933 18.7631 13.0786 18.7642 12.438 19.3824C11.7621 20.0347 11.7635 21.1179 12.441 21.7685Z",
    fill: "#E62645"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigCheckmark);
export default __webpack_public_path__ + "static/media/bigCheckmark.fb2c2834a21f4f7223435f8b6a897593.svg";
export { ForwardRef as ReactComponent };